// A single dashboard statistic inside a card.
//
// `note` is an optional node rendered under the value — a breakdown or a caveat that
// belongs to this figure. It is a node rather than a string so the tile stays ignorant
// of what it is qualifying; the caller brings its own component. A note that renders
// null simply leaves the tile as it was (.stat is a flex column, so nothing shifts).
export default function StatTile({ label, value, tone = '', note = null }) {
  return (
    <div className="card stat">
      <span className="label">{label}</span>
      <span className={`value ${tone}`}>{value}</span>
      {note}
    </div>
  );
}
